import MCHCHAN from '@/api/module/mchchan.js';
const RULES={
  namespaced: true,
  state: {
    bindList:[],//关联的商户列表
    rulesList:[],//分账规则列表
    rulesInfo:{
      ruleName:'',
      startType:'2',
      rulesReqVOList:[],
      mainMerchant: '', //分账方商户号
      mainMerchantName: '', //主商户名称-应用名称（默认回显）
    }, 
  },
  mutations: {
    bindList(state,data){
      state.bindList=data;
    },
    rulesList(state,data){
      state.rulesList=data?data:[];
    },
    rulesInfo(state,data){
      data.startType=data.startType.toString();
      state.rulesInfo=data;
    },
  },
  actions: {
    // 获取绑定商户列表
    async getBindList({commit}, params) {
      try{
        const result = await MCHCHAN.getBindList(params);
        commit('bindList', result);
        return Promise.resolve(result);
       }catch(err){
        return Promise.reject(err);
       }
    },
    //添加分账规则
    // eslint-disable-next-line
    async saveRules({commit}, params){
       try{
        const result = await MCHCHAN.saveRules(params);
        return Promise.resolve(result);
       }catch(err){
        return Promise.reject(err);
       }
    },
    //获取分账规则
    async getRulesAll({commit},params){
      try{
          const result = await MCHCHAN.getRulesAll(params);
          commit('rulesList', result);
          return Promise.resolve(result);
      }catch(err){
         return Promise.reject(err);
      }
    },
    //删除分账规则
     // eslint-disable-next-line
    async deleteRule({commit},params){
      try{
          const result = await MCHCHAN.deleteRule(params);
          return Promise.resolve(result);
      }catch(err){
         return Promise.reject(err);
      }
    },
    //启用分账规则
    // eslint-disable-next-line
    async startRule({commit},params){
      try{
          const result = await MCHCHAN.startRule(params);
          return Promise.resolve(result);
      }catch(err){
         return Promise.reject(err);
      }
    },
     //分账规则详情  
    async queryRule({commit},params){
      try{
          const result = await MCHCHAN.queryRule(params);
          commit('rulesInfo', result);
          return Promise.resolve(result);
      }catch(err){
         return Promise.reject(err);
      }
    },
     //修改分账规则
     // eslint-disable-next-line  
    async updateRule({commit},params){
      try{
          const result = await MCHCHAN.updateRule(params);
          return Promise.resolve(result);
      }catch(err){
         return Promise.reject(err);
      }
    },
  },
  getters: {

  }
} 
export default RULES